export const getBlockTutorialVisibility = ({
  isMobile = false,
  isLegacyCoach = false,
  coachUseLegacyPlanView = false,
  hasDismissedBlockViewBanner = false,
  shouldShowProgramBlockViewTutorial = false,
} = {}) => {
  const canShowBlockTutorialUI = !isMobile;

  const shouldShowNonLegacyBlockTutorial = Boolean(
    canShowBlockTutorialUI &&
      !isLegacyCoach &&
      shouldShowProgramBlockViewTutorial
  );

  const shouldShowBlockViewBanner = Boolean(
    canShowBlockTutorialUI &&
      isLegacyCoach &&
      !coachUseLegacyPlanView &&
      !hasDismissedBlockViewBanner
  );

  return {
    shouldShowNonLegacyBlockTutorial,
    shouldShowBlockViewBanner,
  };
};

export const shouldReduceBlockViewHeaderGap = ({
  isShowingDashboard = false,
  isLegacyPlanViewActive = false,
  shouldShowBlockViewBanner = false,
  shouldShowNonLegacyBlockTutorial = false,
  shouldShowProtocolsGuideBlockView = false,
} = {}) =>
  Boolean(
    !isShowingDashboard &&
      !isLegacyPlanViewActive &&
      !shouldShowBlockViewBanner &&
      !shouldShowNonLegacyBlockTutorial &&
      !shouldShowProtocolsGuideBlockView
  );

export const getBlockHeaderBottomMargin = ({
  isShowingDashboard = false,
  shouldShowBlockViewBanner = false,
  shouldReduceBlockViewHeaderGap = false,
} = {}) => {
  if (isShowingDashboard) return 16;
  if (shouldShowBlockViewBanner) return 16;
  return shouldReduceBlockViewHeaderGap ? 16 : 24;
};
